{
  "name": "adk-portal-admin",
  "version": "1.6.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "buildprod": "ng build --configuration production",
    "buildtesting": "ng build --configuration testing",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "e2e": "playwright test",
    "e2e:install": "playwright install chromium"
  },
  "private": true,
  "engines": {
    "node": "^20.19.0 || ^22.12.0 || >=24.0.0"
  },
  "dependencies": {
    "@accesso/adk-portal-shared": "^1.7.3",
    "@accesso/cc-std-lib": "3.0.10",
    "@accesso/ng-uds": "^10.5.13",
    "@accesso/uds-icons": "^1.3.4",
    "@angular/animations": "20.3.34",
    "@angular/cdk": "20.2.14",
    "@angular/common": "20.3.34",
    "@angular/compiler": "20.3.34",
    "@angular/core": "20.3.34",
    "@angular/forms": "20.3.34",
    "@angular/platform-browser": "20.3.34",
    "@angular/platform-browser-dynamic": "20.3.34",
    "@angular/router": "20.3.34",
    "@okta/okta-angular": "^6.2.0",
    "@okta/okta-auth-js": "^7.4.2",
    "angular-auth-oidc-client": "^17.0.0",
    "core-js": "^3.38.1",
    "feather-icons": "^4.29.0",
    "github-markdown-css": "^5.8.1",
    "jwt-decode": "^4.0.0",
    "lru-cache": "^11.0.0",
    "marked": "^15.0.0",
    "ngx-markdown": "^20.1.0",
    "oidc-client-ts": "^3.0.0",
    "phone": "^3.1.49",
    "primeflex": "^3.3.1",
    "primeicons": "^7.0.0",
    "primeng": "20.4.0",
    "rimraf": "^6.0.1",
    "rtlcss-webpack-plugin": "^4.0.7",
    "rxjs": "~7.8.0",
    "swagger-ui": "^5.34.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.41",
    "@angular/cli": "20.3.41",
    "@angular/compiler-cli": "20.3.34",
    "@angular/localize": "20.3.34",
    "@ianvs/prettier-plugin-sort-imports": "^4.2.1",
    "@playwright/test": "^1.64.1",
    "@types/jasmine": "~5.1.0",
    "@types/swagger-ui": "^3.52.4",
    "angular-eslint": "20.7.0",
    "autoprefixer": "^10.4.20",
    "eslint": "^9.9.1",
    "eslint-config-prettier": "9.1.2",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.47",
    "prettier": "^3.3.2",
    "prettier-plugin-tailwindcss": "^0.6.5",
    "tailwindcss": "^3.4.14",
    "tailwindcss-animate": "^1.0.7",
    "typescript": "~5.9.3",
    "typescript-eslint": "8.67.0"
  },
  "optionalDependencies": {
    "@rollup/rollup-linux-x64-gnu": "4.40.0"
  },
  "overrides": {
    "tar": "^7.5.19",
    "webpack-dev-server": "^5.2.6",
    "@babel/runtime": "^7.26.10",
    "eslint-config-prettier": "9.1.2",
    "uuid": "^14.0.1",
    "swagger-ui": {
      "react": "18.3.1",
      "react-dom": "18.3.1"
    }
  }
}
